import React, { PureComponent } from 'react';
import { Tooltip } from 'antd';
import moment from 'moment';
import PropTypes from 'prop-types';
import MessageBubble from './MessageBubble';
import { employeeAvatarLink } from '../helper';

class MessagesPanel extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      readReceiptAvatars: null,
      participants: [],
    };

    this.readReceiptsContainer = React.createRef();
  }

  componentDidMount() {
    const { currentConversation } = this.props;
    this.scrollToBottom();
    this.getConversationParticipants(currentConversation);
    this.renderSeenByAvatars(currentConversation);
    currentConversation.on('memberJoined', () => {
      this.getConversationParticipants(currentConversation);
    });
    currentConversation.on('memberLeft', () => {
      this.getConversationParticipants(currentConversation);
    });
  }

  componentDidUpdate(prevProps) {
    const { currentConversation, messages, hasSentMessage } = this.props;

    if (hasSentMessage === true) {
      this.scrollToBottom();
    }

    if (
      prevProps.currentConversation !== currentConversation ||
      prevProps.messages.length !== messages.length
    ) {
      this.getConversationParticipants(currentConversation);
      this.renderSeenByAvatars(currentConversation);
    }
  }

  getConversationParticipants = (conversation) => {
    conversation.getParticipants().then((participants) => {
      this.setState({ participants });
    });
  };

  scrollToBottom() {
    this.readReceiptsContainer.current.scrollIntoView();
  }

  renderSeenByAvatars = async (conversation) => {
    const { participants } = this.state;
    const messagesList = await conversation.getMessages();

    if (messagesList.items.length > 0) {
      const lastMessage = messagesList.items[messagesList.items.length - 1];

      const lastMessageTimestamp = lastMessage.state.timestamp;
      const conversationReadReceipts =
        conversation.attributes.read_receipts || {};

      if (Object.entries(conversationReadReceipts).length > 0) {
        const avatarBubbles = Object.entries(conversationReadReceipts).map(
          ([email, readTimestamp]) => {
            const participant = participants.find(
              (p) => p.state.identity === email,
            );
            if (
              participant &&
              Date.parse(readTimestamp) > Date.parse(lastMessageTimestamp)
            ) {
              return (
                <Tooltip
                  key={email}
                  placement="rightBottom"
                  title={`Seen ${moment(readTimestamp).format(
                    'MMM Do YYYY, h:mm a',
                  )} by ${participant.state.attributes.name}`}
                >
                  <span style={{ marginRight: '5px' }}>
                    {employeeAvatarLink(
                      participant.state.attributes.avatar_image_url,
                      20,
                    )}
                  </span>
                </Tooltip>
              );
            }
            return null;
          },
        );
        this.setState({ readReceiptAvatars: avatarBubbles });
      }
    }
  };

  render() {
    const { messages, identity } = this.props;
    const { readReceiptAvatars, participants } = this.state;

    return (
      <div id="messages-panel">
        <ul>
          {messages.map((m) => {
            if (m.state.author === identity)
              return (
                <MessageBubble
                  key={m?.state?.sid}
                  direction="outgoing"
                  message={m}
                  participants={participants}
                />
              );
            return (
              <MessageBubble
                key={m?.state?.sid}
                direction="incoming"
                message={m}
                participants={participants}
              />
            );
          })}
        </ul>
        <span
          style={{
            color: '#747474',
            fontSize: '12px',
            margin: '8px 0 20px 0',
            float: 'right',
            display: 'flex',
            alignItems: 'center',
          }}
          ref={this.readReceiptsContainer}
        >
          {readReceiptAvatars}
        </span>
      </div>
    );
  }
}

MessagesPanel.propTypes = {
  identity: PropTypes.string.isRequired,
  messages: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default MessagesPanel;
